<template>
  <div class="fader">
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <slot v-if="contentVisible"> </slot>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    timeout: { type: Number, default: 2000 },
  },
  data: () => ({
    contentVisible: false,
  }),
  methods: {
    show() {
      if (this.timeoutCall) {
        clearTimeout(this.timeoutCall)
      }
      this.timeoutCall = setTimeout(this.hide, this.timeout)
      this.contentVisible = true
    },
    hide() {
      this.contentVisible = false
    },
  },
}
</script>
